import { LANGUAGE_CODE_TO_TITLE } from '@src/constants/Language';

export const getLanguageOptions = (supportedLanguages, allLanguages) => {
  const sourceLanguages = supportedLanguages.map(code => ({
    code,
    name: `${code.toUpperCase()} - ${LANGUAGE_CODE_TO_TITLE[code]}`,
  }));
  const destinationLanguages = allLanguages
    .map(({ code, name }) => ({
      code,
      name: `${code.toUpperCase()} - ${name}`,
    }))
    .filter(({ code }) => !supportedLanguages.includes(code));
  return [sourceLanguages, destinationLanguages];
};
